import { IBrandingColorSet, IBrandConfiguration } from './../university_branding_interface';

export class UniversityBrandingSettings {
  private brandColorSettings: IBrandingColorSet;
  private brandConfig: IBrandConfiguration;
  private styleTemplate: string;

  constructor() {
    this.brandColorSettings = {};
    this.brandConfig = {};

    //
    // .university-primary-bkg-10 {
    //   background-color: {{tint.tint_10}};
    // }
    //

    this.styleTemplate = `
    .university-primary-bkg {
      background: {{primary}};
      color: {{text}};
    }
    .university-primary-txt {
      color: {{primary}};
    }
    .university-primary-bdr {
      border-color: {{primary}};
    }
    .university-primary-bkg-10 {
      background-color: var(--hi-color--university-10);
    }
    .university-secondary-bkg {
      background: {{secondary}};
    }
    .university-secondary-txt {
      color: {{secondary}};
    }
    .university-secondary-bdr {
      border-color: {{secondary}};
    }`;
  }

  setBrandingDefaultColor(newBrandingColorSet: IBrandingColorSet): void {
    this.brandColorSettings = newBrandingColorSet;
  }

  getBrandingDefaultColor(): IBrandingColorSet {
    return this.brandColorSettings;
  }

  getBrandingConfiguration(): IBrandConfiguration {
    return this.brandConfig;
  }

  updateBrandConfiguration(defaultConfig: IBrandConfiguration, newConfig: IBrandConfiguration): IBrandConfiguration {
    this.brandConfig = _.merge(defaultConfig, newConfig);
    return this.brandConfig;
  }

  addBrandingStyle(additionalStyle: string): void {
    this.styleTemplate += additionalStyle;
  }

  getBrandingTemplate(): string {
    return this.styleTemplate;
  }

  $get() {
    return this;
  }
}

angular.module('ui-ng-university-branding').provider('universityBrandingSettings', UniversityBrandingSettings);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-university-branding/src/lib/university_branding_service.ts